import ENV from '../env';
import Rollbar from 'rollbar/dist/rollbar.umd.js';

// global Rollbar instance
let rollbar;

// Initialize Rollbar if config is available
if ((ENV || {}).PUSHBOT_ROLLBAR_KEY) {
  const locRegex = /^(https?):\/\/[a-zA-Z0-9._-]+\.pushbot\.(com|io)(.*)/;
  rollbar = new Rollbar({
    accessToken: ENV.PUSHBOT_ROLLBAR_KEY,
    captureUncaught: true,
    captureUnhandledRejections: true,
    transform(payload) {
      const trace = ((payload || {}).body || {}).trace || {};
      if (!trace.frames) {
        return;
      }

      trace.frames = trace.frames.map(function(frame) {
        if (!frame.filename) return frame;
        const m = frame.filename.match(locRegex);
        if (!m) return frame;
        frame.filename = m[1] + '://dynamichost' + m[3];
        return frame;
      });
    },
    payload: {
      environment: ENV.PUSHBOT_ENV,
      client: {
        javascript: {
          source_map_enabled: true,
          code_version: ENV.PUSHBOT_VERSION,
          guess_uncaught_frames: true
        }
      }
    }
  });
  // eslint-disable-next-line no-unused-vars, (promise)
  rollbar.handleUnhandledRejection = function(reason, promise) {
    reason = reason || {}; // reason is null in some browsers

    let message = 'Unhandled rejection';
    if (reason.message) {
      message += ': ' + reason.message;
    }

    const status = reason.status || (reason.response || {}).status;
    if (status && status >= 400 && status < 500) {
      return this.warn(reason, message);
    }

    return this.error(reason, message);
  };
}

export default function getRollbar() {
  return rollbar;
}



// WEBPACK FOOTER //
// ./js/util/rollbar.js